module.exports = __webpack_public_path__ + "static/media/ag-shop1Home.ffe3e35e.jpg";